import React from "react";
import "./SattaLayout.css";
import SattaCard from "./SattaCard";

const SattaLayout = () => {
  return (
    <div className="satta-container">
      <h2 className="satta-heading">Game खेलने के लिए Whatsapp पर Msg करे</h2>

      <div className="satta-row">
        <SattaCard
          title="Satta Wala"
          subtitle="Ghaziabad morning | Dubai Game | Faridabad night"
          description="🔥 Direct company se leak jodi 🔥
          Game singal jodi mai he milega, game kisi ka baap nahi kaat sakta."
          // buttonText="Satta Wala"
        />

        <SattaCard
          title="DELHI SATTA BAZAR"
          subtitle="Ghaziabad morning | Dubai Game | Faridabad night"
          description="🔥 Apni booking karane ke liye WhatsApp ya Call kare."
          // buttonText="Delhi Satta"
        />

        <SattaCard
          title="GHAZIABAD SATTA"
          subtitle="Ghaziabad morning | Dubai Game | Faridabad night"
          description="🔥 Game kisi bhi time confirm hoga."
          // buttonText="Ghaziabad Satta"
        />
      </div>
    </div>
  );
};

export default SattaLayout;
